export default __webpack_public_path__ + "static/immunity-396268239861e1335d72b864552bfaff.png";